/*
  DUPPO MD — <duppo-bundle-bar>: „x din 3 alese” din /cart.js (portat din Nubra nubra-card.js §3).
  - O SINGURĂ buclă de re-citire odată: evenimentele coșului vin în rafale și pot sosi înainte ca /cart.js să
    reflecte schimbarea → recitim la 150/400/800/1500 ms până se schimbă semnătura coșului.
  - Fără MutationObserver (pe Nubra declanșa bucle paralele de /cart.js — practici §10.15).
  - „Vezi coșul” deschide sertarul temei (butonul din header), altfel merge la /cart.
*/
(() => {
  if (customElements.get('duppo-bundle-bar')) return;

  const EVENTS = ['shopify:cart:lines-update', 'shopify:cart:update', 'cart:update', 'cart-section:restored'];

  class DuppoBundleBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._sig = null;
      this.refresh = this.refresh.bind(this);
      this.settle = this.settle.bind(this);
      for (const n of EVENTS) document.addEventListener(n, this.settle);
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
      this.addEventListener('click', (e) => {
        const a = e.target instanceof Element && e.target.closest('[data-dbb-cart]');
        if (!a) return;
        const opener = document.querySelector('[data-testid="cart-drawer-trigger"], button[aria-controls="cart-drawer"]');
        if (opener) { e.preventDefault(); opener.click(); }
      });
      this.watchAvoid();
      this.refresh();
    }

    /* nu acoperim butonul „Filtrează” de pe mobil: cât timp e în zona barei, bara coboară din ecran */
    watchAvoid() {
      let raf = 0;
      const check = () => {
        raf = 0;
        const h = this.offsetHeight || 64;
        let hit = false;
        for (const el of document.querySelectorAll('.facets-toggle__button, [data-dbb-avoid]')) {
          if (!el.offsetParent) continue;
          const r = el.getBoundingClientRect();
          if (r.bottom > innerHeight - h && r.top < innerHeight) { hit = true; break; }
        }
        this.classList.toggle('is-tucked', hit);
      };
      const queue = () => { if (!raf) raf = requestAnimationFrame(check); };
      window.addEventListener('scroll', queue, { passive: true, capture: true });
      window.addEventListener('resize', queue, { passive: true });
      queue();
    }

    async settle() {
      if (this._settling) { this._again = true; return; }
      this._settling = true;
      try {
        const before = this._sig;
        for (const wait of [150, 400, 800, 1500]) {
          await new Promise((r) => setTimeout(r, wait));
          await this.refresh();
          if (this._sig !== before) break;
        }
      } finally {
        this._settling = false;
      }
      if (this._again) { this._again = false; this.settle(); }
    }

    async refresh() {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const r = await fetch(`${root}cart.js?t=${Date.now()}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const cart = await r.json();
        this._sig = `${cart.item_count}|${cart.total_price}`;
        const size = Number(this.getAttribute('size') || 3);
        /* doar liniile plătibile (fără carduri cadou / produse la 0) */
        const count = (cart.items || []).reduce((n, it) => n + ((it.original_price ?? it.price) > 0 && !it.gift_card ? it.quantity : 0), 0);
        const inSet = count === 0 ? 0 : count % size || size;
        this.querySelectorAll('[data-slot]').forEach((s, i) => s.classList.toggle('is-full', i < inSet));
        const n = this.querySelector('[data-n]');
        if (n) n.textContent = String(inSet);
        const msg = this.querySelector('[data-msg]');
        if (msg) {
          const ds = this.dataset;
          let tpl = ds.msgEmpty;
          if (inSet === size) tpl = ds.msgDone;
          else if (inSet > 0) tpl = size - inSet === 1 ? ds.msgOne || ds.msgLeft : ds.msgLeft;
          msg.textContent = (tpl || '').replace('[n]', String(size - inSet));
        }
        this.classList.toggle('has-items', count > 0);
        this.classList.toggle('is-done', inSet === size);
      } catch (e) {
        /* coș indisponibil: bara rămâne cum e */
      }
    }
  }

  customElements.define('duppo-bundle-bar', DuppoBundleBar);
})();
